import { toast } from 'sonner';

import { ENV } from '@/shared/config/env';

import { extractApiErrorDetail } from '../errors/extractApiErrorDetail';

export interface NotifyErrorOptions {
  description?: string;
}

export const notify = {
  error: (title: string, error?: unknown, options?: NotifyErrorOptions) => {
    if (ENV.isProduction) {
      return;
    }

    const description = options?.description ?? extractApiErrorDetail(error) ?? 'Please try again.';
    toast.error(title, { description });
  },
};
